/// <amd-module name="Analytics/Shared/Visuals/Common/SupportedColors" />
/**
 * This lists the supported colors that can be used for chart data lines in visuals.
 */
export enum SupportedColors {
    /** Corresponds to color #107C10 */
    Passed = "#107C10",
    /** Corresponds to color #E81123 */
    Failed = "#E81123",
    /** Corresponds to color #F8A800 */
    NotApplicable = "#F8A800",
    /** Corresponds to color #374649 */
    Blocked = "#374649",
    /** Corresponds to color #A6A6A6 */
    NotRun = "#A6A6A6"
}
